import type { CalendarEventDTO } from './types';

/**
 * Otomatik bot kararı — masaüstü döngüsü (services/autoJoin.ts), arayüzdeki
 * düğmeler ve web sunucusunun döngüsü (web/lib/jobs/auto-join.ts) aynı kuralı
 * uyguluyor:
 *  - toplantının kendi düğmesi önce gelir: elle kapatılan (excluded) gitmez,
 *    elle açılan (included) genel ayar kapalı olsa da gider;
 *  - dokunulmamış toplantıda genel ayar geçerli; kabul şartı yok, yalnızca
 *    reddedilen toplantılar atlanır.
 */
export interface AutoJoinChoices {
  autoJoinBot: boolean;
  autoJoinExcluded: string[];
  autoJoinIncluded: string[];
}

/** Bot gönderilebilecek toplantı: Meet/Zoom/Teams linki var, tüm gün değil. */
export function isBotJoinable(event: CalendarEventDTO): boolean {
  return !event.isAllDay && Boolean(event.conference && event.conference.provider !== 'other');
}

/** Kullanıcının seçimine göre bu toplantıya bot gitsin mi (zaman ve plan kontrolleri hariç). */
export function wantsAutoJoin(event: CalendarEventDTO, choices: AutoJoinChoices): boolean {
  if (choices.autoJoinExcluded.includes(event.id)) return false;
  if (choices.autoJoinIncluded.includes(event.id)) return true;
  return choices.autoJoinBot && event.responseStatus !== 'declined';
}
